import { Anchor, Stack, Text, Title } from "@mantine/core";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <Stack align="center" gap="md" py="xl">
      <Title order={1}>404</Title>
      <Text c="dimmed">The page you're looking for doesn't exist.</Text>
      <Anchor component={Link} to="/">
        ← Back home
      </Anchor>
    </Stack>
  );
}
